import React from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { TrendingUp, TrendingDown } from 'lucide-react';
import './KPICard.css';

/**
 * KPI Card Component
 * Display key performance indicator with optional trend
 */
const KPICard = ({
  title,
  value,
  icon: Icon,
  trend,
  loading = false,
  color = 'primary',
  suffix = '',
  prefix = '',
  // #021749 — thẻ bấm được (dùng cho ô "Tiền Két Hiện Tại" mở lịch sử biến động). Không truyền
  // `onClick` thì thẻ giữ nguyên hành vi cũ: tĩnh, không con trỏ tay, không bắt phím.
  onClick,
  clickHint,
  // #174558 — chỉ số phụ hiện NGAY BÊN CẠNH con số chính (vd "Chờ thanh toán" cạnh
  // "Tổng doanh thu"). Không truyền `valueAside` thì thẻ giữ nguyên hành vi cũ.
  valueAside,
}) => {
  const colorVariants = {
    primary: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    error: '#f5222d',
    danger: '#f5222d',
    info: '#1890ff',
  };

  const backgroundColor = colorVariants[color] || colorVariants.primary;

  const clickable = typeof onClick === 'function';

  return (
    <Card
      className={`kpi-card mb-3${clickable ? ' kpi-card-clickable' : ''}`}
      onClick={clickable ? onClick : undefined}
      // Bàn phím + trình đọc màn hình: thẻ bấm được phải tab tới và Enter/Space được, không chỉ
      // đổi con trỏ chuột.
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      title={clickable ? clickHint : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
    >
      <Card.Body>
        {loading ? (
          <div className="text-center py-3">
            <Spinner animation="border" size="sm" />
          </div>
        ) : (
          <>
            <div className="kpi-card-header">
              {Icon && (
                <div
                  className="kpi-card-icon"
                  style={{ backgroundColor: `${backgroundColor}15` }}
                >
                  <Icon
                    size={24}
                    style={{ color: backgroundColor }}
                  />
                </div>
              )}
              <div className="kpi-card-title">{title}</div>
            </div>

            <div className="kpi-card-value-row">
              <div className="kpi-card-value">
                {prefix}
                {typeof value === 'number' ? value.toLocaleString('vi-VN') : value}
                {suffix}
              </div>
              {valueAside && (
                <div className="kpi-card-value-aside">{valueAside}</div>
              )}
            </div>

            {clickable && clickHint && (
              <div className="kpi-card-hint">{clickHint}</div>
            )}

            {trend && (
              <div className={`kpi-card-trend ${trend.isPositive ? 'positive' : 'negative'}`}>
                {trend.isPositive ? (
                  <TrendingUp size={16} />
                ) : (
                  <TrendingDown size={16} />
                )}
                <span>{Math.abs(trend.value)}%</span>
                <span className="trend-label">so với kỳ trước</span>
              </div>
            )}
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default KPICard;


